import React, { useEffect, useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import {
  Box,
  Typography,
  Alert,
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Chip,
  Link,
} from '@mui/material';
import { toast } from 'react-toastify';
import api from '../../utils/api';

const MyTeamJobs = () => {
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const r = await api.get('/my-team/jobs');
        if (!cancelled) setJobs(r.data?.data?.jobs || []);
      } catch (e) {
        if (!cancelled) {
          toast.error(e.response?.data?.message || 'Failed to load team jobs');
          setJobs([]);
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" p={4}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="h5" sx={{ fontWeight: 700, mb: 1 }}>
        My Team Jobs
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Job requirements where a direct report is an owner (recruiter) or created the job.
      </Typography>

      {!jobs.length ? (
        <Alert severity="info">No jobs found for your team yet.</Alert>
      ) : (
        <TableContainer component={Paper} variant="outlined">
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Code</TableCell>
                <TableCell>Title</TableCell>
                <TableCell>Client</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Team link</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {jobs.map((j) => (
                <TableRow key={j.id} hover>
                  <TableCell>
                    <Link component={RouterLink} to={`/jobs/${j.id}`}>
                      {j.job_code}
                    </Link>
                  </TableCell>
                  <TableCell>{j.title}</TableCell>
                  <TableCell>{j.client?.company_name || '—'}</TableCell>
                  <TableCell>
                    <Chip size="small" label={j.status} />
                  </TableCell>
                  <TableCell>
                    {j.is_created_by_team && <Chip size="small" sx={{ mr: 0.5 }} label="Created by team" />}
                    {(j.team_owner_contacts || []).length > 0 && (
                      <Chip
                        size="small"
                        color="primary"
                        variant="outlined"
                        label={`Owner: ${j.team_owner_contacts.map((c) => `${c.first_name} ${c.last_name}`.trim()).join(', ')}`}
                      />
                    )}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Box>
  );
};

export default MyTeamJobs;
